<template>
  <van-field ref="img"
             :class="{fieldUpload:true,imgCenter}"
             :label="label"
             :placeholder="placeholder"
             :labelWidth="labelWidth"
             :rules="rulesInner"
             :clearable="clearable"
             v-model="innerValue"
             :required="required"
  >
    <template #input>
      <div>
        <div v-if="loadingInner" class="van-uploader__preview">
          <van-loading />
        </div>
        <img v-else-if="innerValue"  :src="getFileViewUrl(innerValue)" :width="width" @click="()=>$refs.file.click()" style="display: block;">
        <div v-else-if="slotInput" @click="()=>$refs.file.click()">
          <span v-if="requiredNew" style="position: absolute;color: red;">*</span>
          <slot :innerValue="innerValue">
          </slot>
        </div>
        <div v-else class="" @click="()=>$refs.file.click()" style="line-height: 0;">
          <slot name="icon" :innerValue="innerValue">
            <i class="van-icon van-icon-photograph van-uploader__upload-icon" style="font-size: 70px;padding:16px; border: 1px solid white;border-radius: 50%;"></i>
          </slot>
        </div>
        <input v-show="false" type="file" ref="file" name="file" :accept="accept" @change="afterPicRead"/>
      </div>
    </template>
  </van-field>
</template>

<script>

export default {
  name: "fieldUpload",
  props: {
    slotInput: {default: false},
    slotShow: {default: false},
    imgCenter: {},
    module: {},
    title: {},
    type: {},
    value: {},
    label: {},
    rules: {},
    width: {type: String, default: () => "100%"},
    labelWidth: {},
    placeholder: {},
    required: {},
    disabled: {},
    clearable: {
      default: true
    },
    loading: {default: false},
    accept: {type: String, default: () => "image/*"} // https://developer.mozilla.org/zh-CN/docs/Web/HTML/Element/input/file#%E9%99%90%E5%88%B6%E5%85%81%E8%AE%B8%E7%9A%84%E6%96%87%E4%BB%B6%E7%B1%BB%E5%9E%8B
  },
  data() {
    return {
      innerValue: null,
      innerValueUpload: [],
      loadingInner: false,
      show: false,
      file: null,
    }
  },
  computed: {
    requiredNew() {
      return null !== this.required && false !== this.required
    },
    rulesInner() {
      let pleaseInput = this.type === 'image' ? this.$t('请上传') : this.$t('请输入');
      let list = [{required: this.requiredNew, message: (pleaseInput + ` ` + (this.label || this.title || '')), trigger: 'blur'}]
      if (this.rules) {
        list = list.concat(this.rules)
      }
      return list
    },
  },
  watch: {
    value(newVal) {
      this.innerValue = newVal
    },
    loading(newVal) {
      this.loadingInner = newVal
    },
    innerValue: {
      handler(newVal, oldVal) {
        this.$emit('input', newVal)
        if (newVal !== oldVal) {
          this.$emit('change', newVal, oldVal)
        }
      },
      deep: true
    },
  },
  created() {
    console.log('this.required',this.required)
    console.log('this.rulesInner',this.rulesInner)
    this.innerValue = this.value
  },
  methods: {
    clickUpload(field) {
    },
    afterPicRead(event) {
      console.log('afterPicRead start')
      let files = event.target.files
      let file = files[0];

      // 限制上传大小
      // const MAX_SIZE = 2 * 1024 * 1024 // 2MB in bytes
      // // Check if the file size exceeds the limit
      // if (file.size > MAX_SIZE) {
      //   this.$emit('input:loading', false)
      //   this.loadingInner = false
      //   console.log('File size exceeds limit')
      //   alert('The file is too large. Please choose a file smaller than 2MB.')
      //   return // Stop further execution
      // }

      // 此时可以自行将文件上传至服务器
      this.$emit('input:loading', true)
      this.loadingInner = true
      let formdata = new FormData()
      formdata.append('file', file)
      formdata.append('module', this.module || 'front')
      this.$store.dispatch('common/upload', formdata).then(res => {
        this.innerValue = res[0]
        this.innerValueUpload = [{url: this.getFileViewUrl(this.innerValue), isImg: true, status: 'done'}]
      }).catch(e => {
      }).finally(() => {
        this.$emit('input:loading', false)
        this.loadingInner = false
        console.log('afterPicRead finally')
      })
    },
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .van-field__body {
    justify-content: center;
  }

  .van-uploader__upload {
    margin: initial;
  }
}
.imgCenter {
  ::v-deep .van-field__control{
    justify-content: center;
  }

  //margin: auto;
  //text-align: center;
}
.imgCenter::after {
  border-bottom: none !important;
}
</style>
